// This file was automatically generated and should not be edited.
/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_seo_meditations_intro: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Invite more mindfulness and happiness into each day with Yoga International’s audio meditations! Experience the many benefits of meditation—including better sleep, reduced stress, and increased focus—with our on-demand classes. Whether you’re a beginner or an advanced meditator, we have the perfect class for you.`,
    es: `¡Practica la felicidad y vive coscientemente todos los días gracias a las meditaciones de audio de Yoga International! Experimenta los muchos beneficios de la meditación, incluyendo un mejor sueño, reducción del estrés y mayor concentración, con nuestras clases . Ya seas principiante o un meditador avanzado, tenemos la clase perfecta para ti.`,
  };
  return phrases[locale] || phrases.en || 'seo_meditations_intro';
};
